const hasMultiLineText = (titleDomElements, parentIndex) => {
  const multiLineText = [...titleDomElements].some((titleElement, index) => {
    const selector = `.in-page-features--${parentIndex} .in-page-features-v3--copy`;
    const parentElement = document.querySelectorAll(selector)[index];
    const scrollWidth = titleElement?.scrollWidth;
    const parentWidth = parentElement?.clientWidth;

    if (scrollWidth >= parentWidth) return titleElement;
  });

  return multiLineText;
};

const updateTitleLineBreaks = (setMultiLineTitle, titleDomElements, parentIndex) => {
  const multiLineText = hasMultiLineText(titleDomElements, parentIndex);

  if (multiLineText) {
    [...titleDomElements].forEach((titleElement, index) => {
      const selector = `.in-page-features--${parentIndex} .in-page-features-v3--copy`;
      const parentElement = document.querySelectorAll(selector)[index];
      const scrollWidth = titleElement?.scrollWidth;
      const parentWidth = parentElement?.clientWidth;

      if (scrollWidth < parentWidth) {
        const title = titleElement?.textContent;
        const multiLineTitle = title.replace(' ', '<br />');

        titleElement.innerHTML = multiLineTitle;
      }
    });
    setMultiLineTitle(true);
  }
};

const updateTitleHeights = (titleDomElements, setTitleHeight) => {
  const maxTitleHeight = [...titleDomElements]
    .map(titleElement => titleElement.clientHeight)
    .sort(function(a, b) {
      return b - a;
    })[0];
  setTitleHeight(`${maxTitleHeight}px`);
};

const updateContainerHeight = (index, setContainerHeight) => {
  const containerDomElements = document.querySelectorAll(
    '.in-page-features-v3--featured-content-container'
  );

  const maxFeaturedContentHeight = [...containerDomElements]
    .map(containerElement => containerElement.clientHeight)
    .sort(function(a, b) {
      return b - a;
    })[0];

  setContainerHeight(`${maxFeaturedContentHeight}px`);
};

export { updateContainerHeight, updateTitleHeights, updateTitleLineBreaks };
